import { Administracion } from '@/models/Administracion';

/**
 * Interface del estado de las administraciones cacheadas
 */
export interface CAAdministracionesCacheState {
  cache_administraciones: Administracion[];
}

export const CACHE_ADMIN_MUTATION_AGREGAR_ADMIN: string = 'agregarAdministracion';
export const CACHE_ADMIN_MUTATION_ELIMINAR_ADMIN: string = 'eliminarAdministracion';
export const CACHE_ADMIN_MUTATION_OBTENER_UNA_ADMIN: string = 'obtenerUnaAdministracion';
export const CACHE_ADMIN_MUTATION_OBTENER_TODAS_ADMIN: string = 'obtenerTodasAdministracion';

export const CACHE_ADMIN_MUTATION_MODIFICAR_CONSORCIOS_ADMIN: string = 'modificarConsorciosAdmin';